import React, { useEffect, useState } from "react";

export default function Status() {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/health`)
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(() => setStatus("operational"))
      .catch(() => setStatus("unavailable"));
  }, []);

  const available = status === "operational";
  return <main data-testid="status-page" className="min-h-[65vh] bg-pipeco-dark text-white flex items-center">
    <section className="container-x px-6 md:px-10 w-full py-20">
      <div className="overline text-emerald-300">PIPECO GROUP</div>
      <h1 className="headline text-4xl md:text-5xl mt-3">System Status</h1>
      <div data-testid="service-status" className="mt-8 max-w-xl border border-white/15 bg-white/5 p-6 flex items-center gap-4">
        <span data-testid="service-status-indicator" className={`w-3 h-3 rounded-full ${available ? "bg-emerald-400" : status === "checking" ? "bg-amber-300" : "bg-red-400"}`}/>
        <div><div className="font-display text-2xl">{available ? "All Systems Operational" : status === "checking" ? "Checking Service Status" : "Service Unavailable"}</div><p className="text-sm text-white/65 mt-1">Public API health endpoint</p></div>
      </div>
    </section>
  </main>;
}